import type { SaveResolutionPlan } from "@/lib/core/schemas/save-roll.schema";

/**
 * The degenerate single-threshold plan: d20 vs a flat threshold. Generic
 * {diceConfig, inspectors} — no ruleset vocab. Replaces the inline
 * flat threshold->inspector fallback the forge/resolve paths used to synthesise
 * (persistence.ts / system.ts).
 */
export const buildFlatThresholdPlan = (
  threshold: number
): SaveResolutionPlan => ({
  diceConfig: { sides: 20 },
  inspectors: [
    {
      type: "comparison",
      operator: "gte",
      value: threshold,
      outcomeId: "success",
    },
    { type: "comparison", operator: "default", value: 0, outcomeId: "failure" },
  ],
});

/**
 * The card/display/audit threshold: the value of the first `gte` comparison
 * inspector. Returns null when the plan carries no `gte` threshold (e.g.
 * a function-inspector-only plan).
 */
export const displayThresholdFromResolutionPlan = (
  plan: SaveResolutionPlan
): number | null => {
  for (const inspector of plan.inspectors) {
    if (inspector.type === "comparison" && inspector.operator === "gte") {
      return inspector.value;
    }
  }
  return null;
};
